export const NAMES = {
  TAG_NAME: "ab-pretty-scroller",
}
